import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { type BackLinkProps } from './types';

const DEFAULT_LABEL_KEY = 'Common.back';

export const BackLink = ({
  label = DEFAULT_LABEL_KEY,
  to = '/login',
  onClick,
  i18nNs,
  className,
}: BackLinkProps): React.ReactElement => {
  const { t } = useTranslation(i18nNs ?? LOCIZE_NS.COMMON);
  const navigate = useNavigate();

  const handleClick = (): void => {
    onClick?.();
    navigate(to);
  };

  return (
    <Button
      variant="link"
      onClick={handleClick}
      className={cn(
        'text-center p-0 h-fit text-sm font-medium text-gray-500 hover:text-gray-700',
        className
      )}
      type="button"
    >
      {t(label, { ns: i18nNs })}
    </Button>
  );
};
